// ETags are opaque. Request completion order is not resource version order:
// a delayed GET must never replace the ETag returned by our own successful save.
export function createResourceVersionStore() {
  const versions = new Map();
  let sequence = 0;
  let generation = 0;
  return {
    clear() { versions.clear(); generation += 1; },
    begin(key, mutation = false, readKey = key) {
      let entry = versions.get(key);
      if (!entry) {
        entry = { etag: null, epoch: 0, pending: 0, accepted: 0, reads: new Map() };
        versions.set(key, entry);
      }
      if (mutation) { entry.epoch += 1; entry.pending += 1; }
      let readState;
      if (!mutation) {
        readState = entry.reads.get(readKey) || { pending: 0, accepted: 0 };
        readState.pending += 1;
        entry.reads.set(readKey, readState);
      }
      return { key, mutation, readKey, readState, epoch: entry.epoch, sequence: ++sequence, generation, etag: entry.etag };
    },
    acceptsRead(ticket) {
      const entry = versions.get(ticket.key);
      return ticket.generation === generation && Boolean(entry)
        && !entry.pending && entry.epoch === ticket.epoch && ticket.sequence >= (ticket.readState?.accepted || 0);
    },
    finish(ticket, { etag = null, success = false, deleted = false } = {}) {
      if (ticket.generation !== generation) return;
      const entry = versions.get(ticket.key);
      if (!entry) return;
      if (ticket.mutation) {
        entry.pending = Math.max(0, entry.pending - 1);
        // Also fence reads started while this mutation was in flight.
        entry.epoch += 1;
      } else if (ticket.readState) {
        ticket.readState.pending -= 1;
        // Keep ordering only for overlapping reads of the same representation.
        // Parallel pages/filters are independent, and finished searches must not
        // leave an unbounded query-string history behind.
        if (!ticket.readState.pending && entry.reads.get(ticket.readKey) === ticket.readState) entry.reads.delete(ticket.readKey);
      }
      if (!success) return;
      if (!ticket.mutation) {
        if (entry.pending || ticket.epoch !== entry.epoch || ticket.sequence < ticket.readState.accepted) return;
        ticket.readState.accepted = ticket.sequence;
      }
      if (ticket.sequence < entry.accepted) return;
      if (deleted) entry.etag = null;
      else if (etag) entry.etag = etag;
      entry.accepted = ticket.sequence;
    },
  };
}
